const initialState = {
  config: {},
  focus: true
};

export default initialState;
